import { render, staticRenderFns } from "./MISClass.vue?vue&type=template&id=5c23a945&scoped=true&lang=pug"
import script from "./MISClass.vue?vue&type=script&lang=js"
export * from "./MISClass.vue?vue&type=script&lang=js"
import style0 from "./MISClass.vue?vue&type=style&index=0&id=5c23a945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c23a945",
  null
  
)

export default component.exports